import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { loginReceived, selectCurrentUser } from '../slices/users';
import { useAppDispatch, useAppSelector } from '../store/hooks';

function AccessTokenContainer() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();

  const user = useAppSelector(selectCurrentUser);

  useEffect(() => {
    if (location?.hash === '' || location?.hash === undefined) {
      history.push('/');
    }
    const hashValues = (location?.hash || '').replace('#', '').split('&');
    let accessToken = 0,
      expireDate = null,
      impersonated = false,
      redirectURL = null;

    for (const v of hashValues) {
      const keyValue = v.split('=');
      if (keyValue[0] === 'access_token') {
        accessToken = keyValue[1];
      }
      if (keyValue[0] === 'expires_in') {
        expireDate = new Date();
        expireDate.setSeconds(expireDate.getSeconds() + +keyValue[1]);
      }
      if (keyValue[0] === 'impersonated') {
        impersonated = keyValue[1] === 'true';
      }
      if (keyValue[0] === 'redirect_url') {
        if (typeof keyValue[1] === 'string') {
          const decoded = decodeURIComponent(keyValue[1]);
          if (decoded.startsWith('/')) {
            const currentURL = new URL(window.location.origin + decoded);
            redirectURL = currentURL.toString();
          }
        }
      }
    }
    if (accessToken) {
      dispatch(
        loginReceived({
          token: accessToken,
          expireDate: expireDate,
          impersonated,
        }),
      );

      const fromURL = localStorage.getItem('fromURL');
      if ((fromURL && fromURL !== '/') || redirectURL) {
        localStorage.removeItem('fromURL');
        window.location.replace(fromURL ? decodeURIComponent(fromURL) : redirectURL);
      }
    }
  }, [dispatch, history, location]);

  useEffect(() => {
    if (user?.isAuthenticated) {
      history.push('/');
    }
  }, [history, user]);

  return null;
}

export default AccessTokenContainer;
